module.exports = __webpack_public_path__ + "img/download_win_text.7f017fe7.png";